import { render, staticRenderFns } from "./NarrativeDisclaimer.vue?vue&type=template&id=5c19fc87&scoped=true&"
import script from "./NarrativeDisclaimer.vue?vue&type=script&lang=js&"
export * from "./NarrativeDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeDisclaimer.vue?vue&type=style&index=0&id=5c19fc87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c19fc87",
  null
  
)

export default component.exports